import React from "react";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  CustomInput
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSlidersH } from "@fortawesome/free-solid-svg-icons";
import { useRouterStore } from "mobx-state-router";

const OptionalColumnsDropdown = ({
  listViewState,
  buildColumnsFunction,
  idPrefix = "col"
}) => {
  const routerStore = useRouterStore();

  const isEnabled = routerStore?.options?.rootStore?.appConfigs?.configs?.optional_columns_enabled;
  const optionalColumns = listViewState.tableOptionalColumns || [];

  if (!isEnabled || optionalColumns.length === 0) {
    return null;
  }

  return (
    <UncontrolledDropdown>
      <DropdownToggle color="primary" caret>
        <FontAwesomeIcon icon={faSlidersH} />
      </DropdownToggle>
      <DropdownMenu right className="optional-columns-dropdown-menu">
        {optionalColumns.map((colId) => (
          <DropdownItem key={colId} toggle={false} className="p-0 mb-1">
            <CustomInput
              type="checkbox"
              id={`${idPrefix}-${colId}`}
              label={listViewState.columnNameMapping.get(colId) || colId}
              checked={listViewState.optionalColumns.includes(colId)}
              onChange={() => {
                listViewState.toggleColumnVisibility(colId);
                const newColumns = buildColumnsFunction(routerStore, listViewState);
                listViewState.setColumns(newColumns);
              }}
            />
          </DropdownItem>
        ))}
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

export default OptionalColumnsDropdown;
